<div *ngIf="!selectedClassificationClass && selectedClassificationSystem">
  <h4 style="text-align:center">{{ 'Klassifizierungs-Set' | translate }}</h4>
  <dx-scroll-view [useNative]="true" showScrollbar="'always'">
    <div class="dx-field">
      <div class="dx-field-label">{{ 'Name' | translate }}</div>
      <div class="dx-field-value">
        <dx-text-box [(value)]="selectedClassificationSystem.name"
                     [showClearButton]="true"
                     [readOnly]="classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                     (onValueChanged)="updateClassificationSystem()">
        </dx-text-box>
      </div>
    </div>
    <div *ngIf="loginService.isAdmin" class="dx-field">
      <div id="isGlobal" class="dx-field-label">{{ 'Global' | translate }}</div>
      <dx-tooltip target="#isGlobal" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
        <div *dxTemplate="let data = data; of: 'content'">{{ 'isGlobalTooltip' | translate }}</div>
      </dx-tooltip>
      <div class="dx-field-value">
        <dx-switch [(value)]="selectedClassificationSystem.isGlobal"
                   [readOnly]="classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                   (onValueChanged)="updateClassificationSystem()">
        </dx-switch>
      </div>
    </div>
    <div class="dx-field">
      <div id="isVisible" class="dx-field-label">{{ 'Sichtbar' | translate }}</div>
      <dx-tooltip target="#isVisible" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
        <div *dxTemplate="let data = data; of: 'content'">{{ 'isVisibleTooltip' | translate }}</div>
      </dx-tooltip>
      <div class="dx-field-value">
        <dx-switch [(value)]="selectedClassificationSystem.isVisible"
                   [readOnly]="classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                   (onValueChanged)="updateClassificationSystem()">
        </dx-switch>
      </div>
    </div>
    <div *ngIf="loginService.isAdmin" class="dx-field">
      <div id="requiredAddon" class="dx-field-label">{{ 'Erforderliches Addon' | translate }}</div>
      <dx-tooltip target="#requiredAddon" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
        <div *dxTemplate="let data = data; of: 'content'">{{ 'requiredAddonTooltip' | translate }}</div>
      </dx-tooltip>
      <div class="dx-field-value">
        <dx-select-box [dataSource]="addonList"
                       [(value)]="selectedClassificationSystem.requiredAddon"
                       [readOnly]="classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                       [searchEnabled]="true"
                       [showClearButton]="true"
                       (onSelectionChanged)="updateClassificationSystem()">
        </dx-select-box>
      </div>
    </div>
  </dx-scroll-view>
</div>

<div *ngIf="selectedClassificationClass" style="height: 100%; display: flex; flex-direction: column;">
  <h4 style="text-align:center">{{ 'Klassifizierungs-Klasse' | translate }}</h4>
  <div class="dx-field">
    <div class="dx-field-label">{{ 'Name' | translate }}</div>
    <div class="dx-field-value">
      <dx-text-box [(value)]="selectedClassificationClass.name"
                    [showClearButton]="true"
                    [readOnly]="classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                    (onValueChanged)="updateClassificationClass($event)">
      </dx-text-box>
    </div>
  </div>
  <div class="dx-field">
    <div class="dx-field-label">{{ 'Nummer' | translate }}</div>
    <div class="dx-field-value">
      <dx-text-box [(value)]="selectedClassificationClass.number"
                    [showClearButton]="true"
                    [readOnly]="classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                    (onValueChanged)="updateClassificationClass($event)">
      </dx-text-box>
    </div>
  </div>
  <div class="dx-field">
    <div id="assignable" class="dx-field-label">{{ 'Auswählbar' | translate }}</div>
    <dx-tooltip target="#assignable" showEvent="mouseenter" hideEvent="mouseleave" [hideOnOutsideClick]="false">
      <div *dxTemplate="let data = data; of: 'content'">{{ 'assignableTooltip' | translate }}</div>
    </dx-tooltip>
    <div class="dx-field-value">
      <dx-switch [(value)]="selectedClassificationClass.assignable"
                  [readOnly]="classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                  (onValueChanged)="updateClassificationClass()">
      </dx-switch>
    </div>
  </div>

  <dx-data-grid style="overflow: hidden;"
                class="px-2 pb-2 h-100"
                [dataSource]="selectedClassificationClass.features"
                [allowColumnReordering]="true"
                [rowAlternationEnabled]="true"
                [allowColumnResizing]="true"
                noDataText="{{ 'keine Merkmale' | translate }}"
                [showBorders]="true"
                (onRowUpdated)="updateClassificationClass()"
                (onRowRemoved)="updateClassificationClass()"
                [masterDetail]="{ enabled: true, template: 'detail' }">

    <dxo-editing mode="cell"
                 [allowUpdating]="!classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                 [allowDeleting]="!classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                 [useIcons]="true">
      <dxo-texts confirmDeleteMessage="{{ 'Wollen Sie den Eintrag wirklich löschen' | translate }}?" confirmDeleteTitle="{{ 'Eintrag löschen' | translate }}"></dxo-texts>
    </dxo-editing>

    <dxo-paging [enabled]="false"></dxo-paging>
    <dxo-scrolling showScrollbar="always"></dxo-scrolling>

    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="ClassificationFeaturesStateNewUIV2"></dxo-state-storing>

    <dxi-column dataField="order" caption="Order" [width]="50"></dxi-column>
    <dxi-column dataField="name" caption="Name"></dxi-column>
    <dxi-column dataField="unit" caption="Einheit" [width]="80"></dxi-column>
    <dxi-column dataField="isRequired" caption="Pflicht" [width]="80"></dxi-column>
    <dxi-column dataField="description" caption="Beschreibung"></dxi-column>
    <dxi-column dataField="valueType" caption="{{ 'Typ' | translate }}" [allowEditing]="false" cellTemplate="responsibleTemplate" [width]="100"></dxi-column>
    <div *dxTemplate="let feature of 'responsibleTemplate'">
      <dx-autocomplete class="dataGridAutocomplete"
                       [minSearchLength]="0"
                       [dataSource]="valueTypeSource"
                       [showDropDownButton]="true"
                       valueChangeEvent="blur"
                       [(value)]="feature.data.valueType"
                       [readOnly]="classificationService.isReadOnlyForUser(selectedClassificationSystem)">
      </dx-autocomplete>
    </div>

    <dxo-toolbar>
      <dxi-item>
        <dx-button (onClick)="addNewFeatureToClassificationClass()"
                   icon="plus"
                   text="{{ 'Neues Feature' | translate }}"
                   [disabled]="classificationService.isReadOnlyForUser(selectedClassificationSystem)"/>
      </dxi-item>
    </dxo-toolbar>

    <div *dxTemplate="let feature of 'detail'">
      <dx-data-grid class="internal-grid"
                    [dataSource]="feature.data.values"
                    [remoteOperations]="false"
                    [allowColumnReordering]="true"
                    [rowAlternationEnabled]="true"
                    [allowColumnResizing]="true"
                    noDataText="{{ 'keine Werte' | translate }}"
                    [showBorders]="true"
                    (onRowUpdated)="updateClassificationClass(undefined, feature.data)"
                    (onRowRemoved)="updateClassificationClass()">

        <dxo-editing mode="cell"
                     [allowAdding]="!classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                     [allowUpdating]="!classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                     [allowDeleting]="!classificationService.isReadOnlyForUser(selectedClassificationSystem)"
                     [useIcons]="true">
          <dxo-texts confirmDeleteMessage="{{ 'Wollen Sie diesen Wert wirklich löschen' | translate }}?" confirmDeleteTitle="{{ 'Wert löschen' | translate }}"></dxo-texts>
        </dxo-editing>

        <dxo-paging [enabled]="false"></dxo-paging>

        <dxo-state-storing [enabled]="true" type="localStorage" storageKey="ClassificationFeaturesValuesStateNewUIV2"></dxo-state-storing>

        <dxi-column dataField="order" caption="{{ 'Nummer' | translate }}" (onValueChanged)="update()" alignment="center" [width]="150" [dataType]="number"></dxi-column>
        <dxi-column dataField="value" caption="{{ 'Wert' | translate }}" (onValueChanged)="update()"></dxi-column>
        <dxi-column dataField="valueId" caption="{{ 'Id' | translate }}" (onValueChanged)="update()"></dxi-column>

        <dxo-toolbar>
          <dxi-item>
            <dx-button (onClick)="addNewFeatureValueToFeature(feature.data)"
                       icon="plus"
                       text="{{ 'Neuer Wert' | translate }}"
                       [disabled]="classificationService.isReadOnlyForUser(selectedClassificationSystem)"/>
          </dxi-item>
        </dxo-toolbar>
      </dx-data-grid>


    </div>
  </dx-data-grid>
</div>

